import Marionette from "backbone.marionette";
import templates from "../../utils/templates";

const Item = Marionette.ItemView.extend({
  tagName: "li",
  className: "list-group-item",
  template: templates.find("report", "customize_report_column"),
});

const DEFAULTS = {
  tagName: "ul",
  id: "custom-report-column-list",
  className: "list-group",
  childView: Item,
};

class Body extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { Body as default };
